__turbopack_context__.v({
  "desktopCta": "styles-module-scss-module__O5RzBq__desktopCta",
  "desktopNav": "styles-module-scss-module__O5RzBq__desktopNav",
  "hamburgerIcon": "styles-module-scss-module__O5RzBq__hamburgerIcon",
  "infoMenu": "styles-module-scss-module__O5RzBq__infoMenu",
  "infoMenuContainer": "styles-module-scss-module__O5RzBq__infoMenuContainer",
  "leftSection": "styles-module-scss-module__O5RzBq__leftSection",
  "links": "styles-module-scss-module__O5RzBq__links",
  "linksContainer": "styles-module-scss-module__O5RzBq__linksContainer",
  "logo": "styles-module-scss-module__O5RzBq__logo",
  "logoSection": "styles-module-scss-module__O5RzBq__logoSection",
  "menuFooter": "styles-module-scss-module__O5RzBq__menuFooter",
  "mobileButtonContainer": "styles-module-scss-module__O5RzBq__mobileButtonContainer",
  "mobileMenuContent": "styles-module-scss-module__O5RzBq__mobileMenuContent",
  "mobileMenuSheet": "styles-module-scss-module__O5RzBq__mobileMenuSheet",
  "mobileNav": "styles-module-scss-module__O5RzBq__mobileNav",
  "navBar": "styles-module-scss-module__O5RzBq__navBar",
  "navLink": "styles-module-scss-module__O5RzBq__navLink",
  "navlink": "styles-module-scss-module__O5RzBq__navlink",
  "right": "styles-module-scss-module__O5RzBq__right",
  "searchSection": "styles-module-scss-module__O5RzBq__searchSection",
  "signInButton": "styles-module-scss-module__O5RzBq__signInButton",
  "signInHeaderBtn": "styles-module-scss-module__O5RzBq__signInHeaderBtn",
  "signInLink": "styles-module-scss-module__O5RzBq__signInLink",
  "slideOutMenu": "styles-module-scss-module__O5RzBq__slideOutMenu",
  "socialLinks": "styles-module-scss-module__O5RzBq__socialLinks",
  "socialMenuContainer": "styles-module-scss-module__O5RzBq__socialMenuContainer",
  "socialsMenu": "styles-module-scss-module__O5RzBq__socialsMenu",
  "srOnly": "styles-module-scss-module__O5RzBq__srOnly",
  "subnavChevron": "styles-module-scss-module__O5RzBq__subnavChevron",
  "subnavLinks": "styles-module-scss-module__O5RzBq__subnavLinks",
  "subnavSection": "styles-module-scss-module__O5RzBq__subnavSection",
  "subnavTrigger": "styles-module-scss-module__O5RzBq__subnavTrigger",
});
